import { render } from "./AccordionPage.vue?vue&type=template&id=a1fec242&ts=true"
import script from "./AccordionPage.vue?vue&type=script&lang=ts"
export * from "./AccordionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__